enum SummaryResultScope {
  Unknown = "unknown",
  Network = "network",
  Servicing = "servicing",
}

enum SummaryResultNetworkType {
  Unknown = "unknown",
  Network = "network",
  Prospect = "prospect",
}

enum SummaryResultType {
  Unknown = "unknown",
  BySpecialtyCount = "bySpecialtyCount",
  ByGeocode = "byGeocode",
  ByState = "byState",
  ByCounty = "byCounty",
  ByNPIStatus = "byNPIStatus",
  ByAddressCount = "byAddressCount",
  BySpecialty = "bySpecialty",
}

export {
  SummaryResultNetworkType,
  SummaryResultScope,
  SummaryResultType,
};
